import React, { FunctionComponent } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

interface Props {
    alt?: string
}

const routes = [
    {
        link: '/dashboard',
        name: 'Dashboard',
    },
    {
        link: '/wallet',
        name: 'Wallet',
    },
    {
        link: '/applications',
        name: 'Applications',
    },
    {
        link: '/settings',
        name: 'Settings',
    },
]

const StyledLink = styled(Link)<{ active: any }>`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;

    &:after {
        height: 3px;
        width: 100%;
        background-color: ${(props) => (props.active ? '#52bd95' : 'transparent')};
        border-radius: 20px;
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0;
    }
`

const NavBar: FunctionComponent<Props> = ({ alt }) => {
    const location = useLocation()
    return (
        <div
            className={`${alt ? 'h-20' : 'h-16 overflow-x-auto overflow-y-hidden'} border-b-2 border-snow-100 bg-white`}
        >
            <div className='flex items-center h-full w-10/12 mx-auto '>
                {alt && (
                    <div>
                        <img src={require('assets/full-logo.svg')} alt='logo svg' className='mr-16' />
                    </div>
                )}
                <nav className='flex items-center h-full'>
                    {location.pathname === '/get-started' && (
                        <StyledLink
                            to='/get-started'
                            active
                            className='text-sm font-semibold text-dark-100 tracking-wide mr-8'
                        >
                            Get Started
                        </StyledLink>
                    )}

                    {routes.map((route) => (
                        <StyledLink
                            key={route.name}
                            to={route.link === '/settings' ? route.link + '/details' : route.link}
                            active={location.pathname.includes(route.link) ? 'true' : undefined}
                            className={`${
                                location.pathname.includes(route.link)
                                    ? 'font-semibold text-dark-100'
                                    : 'text-snow-200 hover:text-dark-100'
                            } text-sm tracking-wide mr-8  duration-500`}
                        >
                            {route.name}
                        </StyledLink>
                    ))}
                </nav>
            </div>
        </div>
    )
}

export default NavBar
